module.exports = __webpack_public_path__ + "img/tijiaochenggong.a3038787.png";